import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 13, viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.129 5.60352L5.106 1.58052L6.1665 0.52002L12 6.35352L6.1665 12.187L5.106 11.1265L9.129 7.10352H0V5.60352H9.129Z", fill: "white" }));
const ForwardRef = forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
